export default class Mercure {
  constructor() {
    this.channels = {};
    this.eventSource = null;
  }

  channel(topic) {
    if (!this.channels[topic]) {
      this.channels[topic] = {};
      this.reconnect();
    }
    const listeners = this.channels[topic];
    const api = {
      listen: (eventName, callback) => {
        (listeners[eventName] ||= []).push(callback);
        return api;
      },
    };
    return api;
  }

  leaveChannel(topic) {
    delete this.channels[topic];
    this.reconnect();
  }

  reconnect() {
    this.eventSource?.close();

    const topics = Object.keys(this.channels);
    if (!topics.length) {
      this.eventSource = null;
      return;
    }

    const url = new URL(`${window.location.origin}/.well-known/mercure`);
    topics.forEach((topic) => url.searchParams.append('topic', topic));

    this.eventSource = new EventSource(url);
    this.eventSource.addEventListener('message', (e) => {
      const payload = JSON.parse(e.data);
      const eventName = payload.event.replace(/^App\\Events\\/, '');
      const listeners = this.channels[payload.channel];
      (listeners?.[eventName] || []).forEach((cb) => cb(payload.data));
    });
  }
}